import { Exclude, Expose } from "class-transformer";

@Exclude()
export class UpdateReserveStoreBindingDto {
    @Expose()
    readonly count: number;
}
